Dates = require 'lib/dates'
React = require 'react'
t = require('views/internal/recup-with-helpers')('canonical_card')
trackUe = require 'debug/trackUe'
Util = require 'lib/util'
_ = require 'underscore'
moment = require 'moment'

{
  ArchivedBadge
  AttachmentsBadge
  Avatar
  Board
  BoardAndListName
  Card
  CardBadges
  CardCover
  CardLabel
  CardLabels
  CardLink
  CardMembers
  CardTitle
  CheckboxFieldBadge
  ChecklistBadge
  CommentsBadge
  DateFieldBadge
  DescriptionBadge
  DueDateBadge
  ListFieldBadge
  ListNameOnly
  NotificationBadge
  NumberFieldBadge
  PlaceholderCard
  SubscribedBadge
  TeamBoardAndListName
  TextFieldBadge
  TrelloAttachmentsBadge
  VotesBadge
} = require '@atlassian/trello-canonical-components/canonical-card'

colors = {
  'business-blue': 'business-blue-500'
  'light-gray': 'light-gray-500'
  black: 'near-black'
  blue: 'trello-blue-500'
  green: 'green-500'
  lime: 'lime-500'
  orange: 'orange-500'
  pink: 'pink-500'
  purple: 'purple-500'
  red: 'red-500'
  sky: 'sky-500'
  yellow: 'yellow-500'
}

boardAndListNameTitle = (boardName, listName) ->
  result = "#{t.l('board')}: #{boardName}"
  if listName?
    result += ", #{t.l('list')}: #{listName}"
  result

boardHeaderColor = (bottomColor, brightness) ->
  if bottomColor
    bottomColor
  else if brightness == 'dark'
    '#333'
  else
    'N30'

class TrackingCardLink extends React.Component
  track: (e) =>
    { tracking, onClick } = @props

    if tracking?
      trackUe(
        tracking.category
        'opens'
        'card'
        tracking.location
        ''
        tracking.method
      )

    onClick?(e)

  render: ->
    React.createElement(
      CardLink,
      _.extend(_.clone(@props), onClick: @track),
      @props.children
    )

class TrackingBoardAndListName extends React.Component
  track: (e) =>
    { tracking, onClick } = @props

    if tracking? && e.target?.matches 'a'
      trackUe(
        tracking.category
        'opens'
        'board'
        tracking.location
        ''
        tracking.method
      )

    onClick?(e)

  render: ->
    React.createElement(
      BoardAndListName,
      _.extend(_.clone(@props), onClick: @track),
      @props.children
    )


class LoadingCanonicalCard extends React.Component
  displayName: 'LoadingCanonicalCard'

  render: t.renderable ->
    t.tag PlaceholderCard

class GenericErrorCanonicalCard extends React.Component
  displayName: 'GenericErrorCanonicalCard'

  render: t.renderable ->
    { errorText } = @props

    t.div '.canonical-card-error', =>
      t.tag Board, { bgColor: 'N40' }, =>
        t.tag Card, { className: 'canonical-card-error-card' }, =>
          t.tag CardCover, {
            bgColor: 'N30'
            height: 40
            img: require('images/canonical-card/alert-taco.svg')
            className: 'error-card-cover'
            width: 38
          }
          t.tag CardTitle, =>
            t.format 'generic error', { message: errorText }

class UnauthorizedCanonicalCard extends React.Component
  displayName: 'UnauthorizedCanonicalCard'

  render: t.renderable ->
    t.div '.canonical-card-error', =>
      t.tag Board, { bgColor: 'N40' }, =>
        t.tag Card, { className: 'canonical-card-error-card' }, =>
          t.tag CardCover, {
            bgColor: 'N30'
            height: 48
            img: require('images/canonical-card/bouncer-taco.svg')
            className: 'unauthorized-card-cover'
          }
          t.tag CardTitle, =>
            t.format 'unauthorized card error'

class ConfusedTacoCanonicalCard extends React.Component
  displayName: 'ConfusedTacoCanonicalCard'

  render: t.renderable ->
    t.div '.canonical-card-error', =>
      t.tag Board, { bgColor: 'N40' }, =>
        t.tag Card, { className: 'canonical-card-error-card' }, =>
          t.tag CardCover, {
            bgColor: 'N30'
            height: 40
            img: require('images/canonical-card/confused-taco.svg')
            className: 'error-card-cover'
            width: 38
          }
          t.tag CardTitle, =>
            t.format @props.error

class NotFoundCanonicalCard extends React.Component
  displayName: 'NotFoundCanonicalCard'

  render: t.renderable ->
    t.tag ConfusedTacoCanonicalCard, { error: 'card not found error' }

class NetworkErrorCanonicalCard extends React.Component
  displayName: 'ServerErrorCanonicalCard'

  render: t.renderable ->
    t.tag ConfusedTacoCanonicalCard, { error: 'network error' }

class InvalidCanonicalCard extends React.Component
  displayName: 'InvalidCardCanonicalCard'

  render: t.renderable ->
    t.tag ConfusedTacoCanonicalCard, { error: 'invalid card error' }

class MinimalCanonicalCard extends React.Component
  displayName: 'MinimalCanonicalCard'

  constructor: (props) ->
    @props = props
    @state = @props

  render: t.renderable ->
    {
      cardName
      cardDue
      cardDueComplete
      cardUrl
      boardName
      boardBgColor
      boardBgBottomColor
      boardBgBrightness
      boardBgImage
      boardUrl
      listName
      isWide
      tracking
    } = @state

    t.div =>
      t.div '.canonical-card', =>
        t.tag Board, {
          bgColor: boardBgColor
          bgImage: boardBgImage
          headerBgColor: if boardBgBottomColor && boardBgBrightness then boardHeaderColor(boardBgBottomColor, boardBgBrightness)
          widthPx: if isWide then 360 else undefined
        }, =>
          t.tag TrackingCardLink, {
            href: cardUrl
            tracking: tracking
          }, =>
            t.tag CardTitle, =>
              t.text cardName
            if cardDue
              t.tag CardBadges, =>
                t.tag DueDateBadge, {
                  dueDate: new Date(cardDue),
                  isComplete: cardDueComplete
                }, =>
                  t.text Dates.toDateString(cardDue)

          t.tag TrackingBoardAndListName, {
            boardName
            boardUrl
            listName
            title: boardAndListNameTitle(boardName, listName)
            tracking: tracking
          }

class CanonicalCard extends React.Component
  displayName: 'CanonicalCard'

  render: t.renderable ->
    {
      board
      boardClassName
      card
      cardClassName
      labels
      list
      members
      numNotifications
      organization
      lightBackground
      showListNameOnly
      onCardClick
      onCardMouseEnter
      onCardMouseLeave
      wideMode
    } = @props

    badges = card.get('badges')
    isArchived = card.get('closed')
    list = list || card.getList()

    t.div =>
      t.div '.canonical-card', =>
        t.tag Board, {
          className: boardClassName
          bgColor: board.getPref('backgroundColor')
          bgImage: Util.smallestPreviewBiggerThan(board.getPref('backgroundImageScaled'), 250, 130)?.url ? board.getPref('backgroundImage')
          headerBgColor: boardHeaderColor(board.getPref('backgroundBottomColor'), board.getPref('backgroundBrightness'))
          widthPx: if wideMode then 360 else undefined
        }, =>
          t.tag CardLink, {
              href: card.get('url')
              className: cardClassName
              onClick: onCardClick
              onMouseEnter: onCardMouseEnter
              onMouseLeave: onCardMouseLeave
            }, =>
            if labels?.length > 0
              t.tag CardLabels, =>
                labels.forEach (label) =>
                  color = label.get('color')
                  if color == null then return

                  t.tag CardLabel, { color: colors[color] }, =>
                    t.text (label.get('name') || ' ')
            t.tag CardTitle, =>
              t.text card.get('name')
            t.tag CardBadges, =>
              if numNotifications > 0
                t.tag NotificationBadge, { numUnread: numNotifications }
              if badges.subscribed
                t.tag SubscribedBadge
              if badges.votes > 0
                t.tag VotesBadge, { numVotes: badges.votes }
              if badges.due?
                t.tag DueDateBadge, { dueDate: new Date(badges.due), isComplete: badges.dueComplete }, =>
                  t.text Dates.toDateString(badges.due)
              if badges.description
                t.tag DescriptionBadge
              if badges.comments > 0
                t.tag CommentsBadge, { numComments: badges.comments }

              trelloAttachments = if badges.attachmentsByType
                badges.attachmentsByType.trello.board + badges.attachmentsByType.trello.card
              else
                0

              attachments = badges.attachments - trelloAttachments
              if attachments > 0
                t.tag AttachmentsBadge, { numAttachments: attachments }
              if trelloAttachments > 0
                t.tag TrelloAttachmentsBadge, { numAttachments: trelloAttachments }
              if badges.checkItems > 0
                t.tag ChecklistBadge, { numItems: badges.checkItems, numComplete: badges.checkItemsChecked }
              if isArchived
                t.tag ArchivedBadge, =>
                  t.format 'archived card badge label'

              if board.customFieldList.length > 0
                board.customFieldList.map (field) ->
                  item = card.customFieldItemList.find (item) -> item.get('idCustomField') == field.id
                  if !item?
                    return null
                  item = item.toJSON()
                  field = field.toJSON()
                  if field.display && !field.display.cardFront
                    return null
                  switch field.type
                    when 'checkbox' then t.tag CheckboxFieldBadge, { field, item }
                    when 'date' then t.tag DateFieldBadge, { field, item }
                    when 'list' then t.tag ListFieldBadge, { field, item }
                    when 'number' then t.tag NumberFieldBadge, { field, item }
                    when 'text' then t.tag TextFieldBadge, { field, item }
                    else null

            if members?.length > 0
              t.tag CardMembers, =>
                for member in members by -1
                  avatarHash = member.get('avatarHash')
                  t.tag Avatar, {
                    deactivated: board.getOrganization()?.getMemberType(member) == 'deactivated'
                    img: avatarHash and [window.avatarDomain, avatarHash, '30.png'].join('/')
                    img2x: avatarHash and [window.avatarDomain, avatarHash, '50.png'].join('/')
                    initials: member.get('initials')
                    lightBackground: if lightBackground then lightBackground else false
                  }

          if showListNameOnly
            t.tag ListNameOnly, {
              listName: list?.get('name')
              title: "#{t.l('list')}: #{list?.get('name')}"
            }
          else
            if organization
              t.tag TeamBoardAndListName, {
                boardName: board?.get('name')
                boardUrl: board?.get('url')
                listName: list?.get('name')
                teamName: organization?.get('displayName')
                title: boardAndListNameTitle(board?.get('name'), list?.get('name'))
              }
            else
              t.tag BoardAndListName, {
                boardName: board?.get('name')
                boardUrl: board?.get('url')
                listName: list?.get('name')
                title: boardAndListNameTitle(board?.get('name'), list?.get('name'))
              }

class MicroCanonicalCard extends React.Component
  displayName: 'MicroCanonicalCard'

  render: t.renderable ->
    {
      badge
      card
      labels
    } = @props

    t.div =>
      t.div '.canonical-card', =>
        t.tag Card, =>
          t.div '.rbc-cust-event-time.badge', =>
            t.text moment(new Date(card.get('due'))).format('LT')
          t.tag CardLabels, =>
            _.map labels, (label) =>
              t.tag CardLabel,
                color: "#{label.get('color')}-500"
          t.tag CardTitle, =>
            t.text card.get('name')
          if badge?
            t.span '.rbc-cust-event-badge.badge', ->
              t.text badge

module.exports = {
  CanonicalCard
  GenericErrorCanonicalCard
  InvalidCanonicalCard
  LoadingCanonicalCard
  MicroCanonicalCard
  MinimalCanonicalCard
  NetworkErrorCanonicalCard
  NotFoundCanonicalCard
  UnauthorizedCanonicalCard
}



// WEBPACK FOOTER //
// ./app/scripts/views/canonical-card/canonical-card-components.coffee